/* Toast = sonner re-export. Toaster deve ser montado uma vez no
   renderer (via providers); toast() pode ser chamado de qualquer lugar. */
import { Toaster as SonnerToaster, type ToasterProps } from 'sonner';

export { toast } from 'sonner';

export function Toaster(props: Readonly<ToasterProps>) {
  return (
    <SonnerToaster
      position="top-right"
      richColors
      closeButton
      toastOptions={{
        classNames: {
          toast:
            'group toast group-[.toaster]:bg-popover group-[.toaster]:text-popover-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg',
          description: 'group-[.toast]:text-muted-foreground',
          actionButton: 'group-[.toast]:bg-primary group-[.toast]:text-primary-foreground',
          cancelButton: 'group-[.toast]:bg-secondary group-[.toast]:text-secondary-foreground',
        },
      }}
      {...props}
    />
  );
}
